import styled from 'styled-components';

export const Wrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black3)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  width: 100%;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ActionWrapper = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DescriptionWrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black7};
  display: flex;
  flex-shrink: 0;
`;

export const CoursesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CourseWrapper = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black7};
  white-space: nowrap;
  max-width: 100%;
`;
